import React from 'react';
import HeaderThree from "../common/header/HeaderThree";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import SingleGeneralContracting4 from '../components/single-service/SingleGeneralContracting4';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const GeneralContracting4 = () => {
    return (
        <>
            <HeaderThree />
            <Breadcrumb
                heading="Sistemas De Ventilação ( HVAC )"
                currentPage="serviço" 
                Img="IMG-20230809-WA0014.jpg"
            />
            <SingleGeneralContracting4 />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default GeneralContracting4;